import MyHomeCloudCustom from "./my-home-cloud-customer";
export default MyHomeCloudCustom;
